const CONTAINERS = {
  FORM_S: 280,
  FORM_M: 380,
  FORM_L: 500,
};

export default CONTAINERS;
